import { render, staticRenderFns } from "./GatewayDetailReplacementHistory.vue?vue&type=template&id=27b6ed6e&scoped=true&"
import script from "./GatewayDetailReplacementHistory.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailReplacementHistory.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayDetailReplacementHistory.vue?vue&type=style&index=0&id=27b6ed6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b6ed6e",
  null
  
)

export default component.exports